export default {
    scroll:{
        en:'Scroll down to view more',
        tc:'向下滾動查看更多',
        sc:'向下滚动查看更多'
    },
    sec1_0:{
        en:'LOOK',
        tc:'傲視',
        sc:'傲视'
    },
    sec1_1:{
        en:'BEYOND LIMITS.',
        tc:'超越極限',
        sc:'超越极限'
    },
    sec1_2:{
        en:'FIND',
        tc:'尋找',
        sc:'寻找'
    },
    sec1_3:{
        en:'TRUE PERFECTION',
        tc:'真正完美',
        sc:'真正完美'
    },
    //
    sec2_0:{
        en:'concept',
        tc:'概念',
        sc:'概念'
    },
    sec2_1:{
        en:'21 Whitfield is a four-star hotel located in Causeway Bay, Hong Kong, China.',
        tc:'第二十一威菲路酒店是一家四星級酒店，位於中國香港銅鑼灣對於尋求活力都市度假的旅客來說，這裡是您理想的選擇。',
        sc:'第二十一威菲路酒店是一家四星级酒店，位于中国香港铜锣湾对于寻求活力都市度假的旅客来说，这里是您理想的选择。'
    },
    sec2_2:{
        en:'It is an ideal choice for travelers seeking a dynamic urban escape. Times Square is only 579 metres away.',
        tc:'距離時代廣場僅 579 公尺。設有 24 小時接待櫃檯及快速辦理入住/退房服務，其便利性無與倫比。寬敞的房間配有空調，提供免費 WiFi 以及令人印象深刻的城市或維港景色。提供舒適難忘的住宿體驗。',
        sc:'距离时代广场仅 579 公尺。设有 24 小时接待柜台及快速办理入住/退房服务，其便利性无与伦比。宽敞的房间配有空调，提供免费 WiFi 以及令人印象深刻的城市或維港景色。提供舒适难忘的住宿体验。'
    },
    sec2_3:{
        en:'With a 24-hour front desk and express check-in/check-out, the convenience is unmatched. Spacious room with air conditioning, free WiFi and impressive city or habour views. Providing a comfortable and unforgettable acommodation experience.',
        tc:'客人可以參觀附近的跑馬地馬場或星光大道等眾多文化景點。從頂層欣賞令人驚嘆的維港景色，非常適合於熱鬧的都市中心放鬆和探索。',
        sc:'客人可以参观附近的跑马地马场或星光大道等众多文化景点。从顶层欣赏令人惊叹的维港景色，非常适合于热闹的都市中心放松和探索。'
    },
    sec2_4:{
        en:'Cultural attractions such as the Avenue of Stars and Happy Valley Racecourse can be visited nearby. Enjoy stunning harbour views from the rooftop, ideal for relaxing and exploring.',
        tc:'',
        sc:''
    },
    //
    sec3_0:{
        en:'rooms',
        tc:'房間',
        sc:'房间'
    },
    sec3_1:{
        en:'List of Rooms',
        tc:'房間列表',
        sc:'房间列表'
    },
    sec3_2:{
        en:'Impressive city or habour views providing a comfortable and unforgettable accommodation experience.',
        tc:'令人印象深刻的城市或維港景，提供舒適而難忘的住宿體驗。',
        sc:'令人印象深刻的城市或維港景，提供舒适而难忘的住宿体验。'
    },
    sec3_3:{
        en:'Enjoy the magnificent harbour views. Ideal for relaxation and exploration.',
        tc:'欣賞壯麗的海港景色。非常適合於城市中心放鬆和探索。',
        sc:'欣赏壮丽的海港景色。非常适合于城市中心放松和探索。'
    },
    sec4_0:{
        en:'facility',
        tc:'酒店設施',
        sc:'酒店设施'
    },
    sec4_1:{
        en:'This authentic, welcoming space offers an atmosphere of privacy and escape.',
        tc:'酒店在熱鬧的都市中心提供一個私密、溫馨的空間讓您逃離喧囂。',
        sc:'酒店在热闹的都市中心提供一个私密、温馨的空间让您逃离喧嚣。'
    },
    sec4_2:{
        en:'Here you can meet someone special. Create lasting memories together.',
        tc:'在這裡您可以與特別的人相遇，並共同創造特別、永恆的回憶。',
        sc:'在这里您可以与特别的人相遇，并共同创造特别、永恒的回忆。'
    },
    sec5_0:{
        en:'spotlight Events',
        tc:'焦點盛事',
        sc:'焦点盛事'
    },
    sec6_0:{
        en:'Reservation',
        tc:'房間預訂',
        sc:'房间预订'
    },
    sec6_1:{
        en:'For long stay please contact us for the latest discount and offers',
        tc:'如有查询及長期住宿需要，請聯絡我們以取得最新優惠及折扣',
        sc:'如有查询及长期住宿需要，请联络我們以取得最新优惠及折扣'
    },
    sec6_2:{
        en:'Phone number：',
        tc:'電話：',
        sc:'电话：'
    },
    sec6_3:{
        en:'Email：',
        tc:'電子郵件：',
        sc:'電子郵件：'
    },
    noNews:{
        en:'No news to display at the moment.',
        tc:'目前沒有新聞可顯示。',
        sc:'当前没有新闻可显示。',
    }
}